import { default as MuiStepper, StepperProps } from '@mui/material/Stepper'

type Props = StepperProps

export function Stepper(props: Props) {
    return <MuiStepper {...props} />
}
